module.exports = __webpack_public_path__ + "img/aftersalesLogo4.16fa6460.png";